// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: var(--mantine-color-gray-0) !important;
}

a {
    text-decoration: none;
    color: inherit;
}

.App {
    max-width: 100vw;
    overflow: hidden;
}

.mantine-Breadcrumbs-root {
    flex-wrap: wrap !important;
}`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;IACI,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["body {\n    background-color: var(--mantine-color-gray-0) !important;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\n.App {\n    max-width: 100vw;\n    overflow: hidden;\n}\n\n.mantine-Breadcrumbs-root {\n    flex-wrap: wrap !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
